<template>
  <div class="aiphoto-box">
    <div :class="['ai-photo-container',activeStep == 3 ? 'ai-height':'']">
      <template v-if="aiLoading">
        <div class="ai-loading-mask">
          <div class="loading-wrapper">
            <div class="icon-circle">
              <i class="el-icon-loading" />
            </div>
            <p class="loading-text">
              正在生成 AI 圖片...
            </p>
            <p class="loading-sub">
              這可能需要大約 10 秒鐘，請勿關閉窗口
            </p>
          </div>
        </div>
      </template>
      <template v-else> 
        <div class="workflow-steps">
          <div :class="['step-item', activeStep >= 1 ? 'is-active' : '']">
            <!-- <div class="step-icon"><i class="el-icon-picture"></i></div> -->
            <span class="step-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use :xlink:href=" activeStep >= 1 ? '#iconxuanzetupianjinhangzhuangtai' : '#iconxuanzetupian'" />
              </svg>
            </span>
            <div :class="['step-label', activeStep == 1 ? 'activetxt' : '']">
              選擇圖片
            </div>
            <div class="step-desc">
              選擇需要處理的圖片
            </div>
          </div>
          <div 
            :class="['step-line', activeStep >= 2 ? 'activeline' : '']"
          />
          <div :class="['step-item', activeStep >= 2 ? 'is-active' : '']">
            <span class="step-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use :xlink:href=" activeStep >= 2 ? '#iconAIfenxijinhangzhuangtai' : '#iconAIfenxi'" />
              </svg>
            </span>
            <!-- <div class="step-icon"><i class="el-icon-magic-stick"></i></div> -->
            <div :class="['step-label', activeStep == 2 ? 'activetxt' : '']">
              AI分析
            </div>
            <div class="step-desc">
              分析並列出雜物清單
            </div>
          </div>
          <div :class="['step-line', activeStep == 3 ? 'activeline' : '']" />
          <div :class="['step-item', activeStep == 3 ? 'is-active' : '']">
            <span class="step-icon">
              <svg
                class="icon"
                aria-hidden="true"
              >
                <use :xlink:href=" activeStep == 3 ? '#iconshibiebingshengchengjinhangzhuangtai' : '#iconshibiebingshengcheng'" />
              </svg>
            </span>
            <!-- <div class="step-icon"><i class="el-icon-finished"></i></div> -->
            <div :class="['step-label', activeStep == 3 ? 'activetxt' : '']">
              識別並生成
            </div>
            <div class="step-desc">
              選取可移除物件並生成
            </div>
          </div>
        </div>
        <div
          v-if="activeStep == 1"
          class="main-content"
        >
          <div
            class="image-grid-title">
            請選擇需要處理的圖片
          </div>
          <div class="image-grid-wrapper">
            <div class="image-grid">
              <!-- :key="index"  -->
              <div 
                v-for="(img, index) in aiImgs" 
                :key="img.imagePath"
                :class="['image-item', img.selected ? 'is-selected' : '']"
                @click="toggleSelect(index)"
              >
                <div v-if="img.status === 'uploading' || !img.imagePath" class="uploading-placeholder">
                  <span>加載中...</span>
                </div>
                <el-image 
                  v-else
                  :src="img.imagePath + '?x-oss-process=style/300xauto_f'" 
                  fit="fill" 
                  class="grid-img"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                    <span>加載失敗</span>
                  </div>
                </el-image>
                <!-- <el-image 
                  :src="img.imagePath + '?x-oss-process=style/300xauto_f'" 
                  fit="cover"
                /> -->
                <!-- <div
                  v-if="img.selected"
                  class="selection-overlay"
                >
                  <i class="el-icon-check" />
                </div> -->
                <!-- <span>{{ img.imagePath }}</span> -->
              </div>
            </div>
          </div>
          <div class="action-panel">
            <h3 class="panel-title">
              處理概覽
            </h3>
            <p class="panel-desc">
              選擇您的樓盤圖片，AI將自動識別並協助優化
            </p>
            
            <div class="stat-item">
              已選圖片：<span class="highlight">{{ selectedCount > 0 ? selectedCount : '--' }}</span>
            </div>

            <div class="ai-notice">
              <h4>AI分析說明</h4>
              <ul>
                <li>* AI分析不扣減任何次數</li>
                <li>* AI將識別雜物、個人物品及影響觀感的物件</li>
              </ul>
            </div>

            <div class="analysis-footer">
              <el-popover
                ref="quotaPopover"
                v-model="showQuotaPop"
                placement="top"
                width="280"
                trigger="manual"
                popper-class="quota-popover"
              >
                <div class="popover-content">
                  <p>
                    AI修圖次數不足，請先於
                    <span class="link-text">「金幣/鑽石管理 > AI修圖」</span>
                    購買AI修圖額度。
                  </p>
                  <p>目前AI修圖次數：{{ aiRetouchCount }}</p>
                  <div class="popover-footer">
                    <el-button
                      type="primary"
                      size="mini"
                      @click="showQuotaPop = false"
                    >
                      確認
                    </el-button>
                  </div>
                </div>
              </el-popover>

              <el-button 
                v-popover:quotaPopover
                type="primary" 
                class="submit-btn" 
                :class="['submit-btn',selectedCount === 0 ? 'disbut':'']"
                :disabled="selectedCount === 0"
                @click="handleButtonClick"
              >
                開始AI分析
              </el-button>
              
              <p class="quota-info">
                AI修圖次數：{{ aiRetouchCount }}
              </p>
              <div class="txt_decor">
                <div>旋轉圖片會造成AI執相後的圖片刪除</div>
                <div>建議可將圖片先旋轉到合適的位置後，再進行下一步</div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="activeStep == 2"
          class="analysis-loading-container"
        >
          <div class="loading-content">
            <h2 class="analysis-title">
              AI深度識別中
            </h2>
            <p class="analysis-subtitle">
              大型語言模型正在分析圖片內容並列出雜物清單
            </p>

            <div class="progress-wrapper">
              <div class="progress-bar-bg">
                <div
                  class="progress-inner"
                  :style="{ width: progress + '%' }"
                >
                  <span class="progress-percent">{{ progress }}%</span>
                </div>
              </div>
              
              <div class="progress-nodes">
                <div :class="['node', progress >= 0 ? 'is-active' : '']">
                  準備中
                </div>
                <div :class="['node', progress >= 50 ? 'is-active' : '']">
                  處理中
                </div>
                <div :class="['node', progress >= 100 ? 'is-active' : '']">
                  完成
                </div>
              </div>
            </div>

            <p class="analysis-notice">
              * AI分析不扣減任何次數
            </p>
          </div>
        </div>
        <div 
          v-if="activeStep == 3" 
          class="step3-container"
        >
          <div class="result-header">
            <div class="header-left">
              <h3>識別結果與物件選取</h3>
              <p>我們已識別出 {{ detailImages.length }} 張圖片中的 {{ globalTags.length }} 個可移除物件。請選擇您希望在生成圖中「消失」的雜物。</p>
            </div>
            <div class="header-right">
              <el-button 
                type="primary" 
                plain 
                size="medium" 
                class="add-img-btn"
                @click="goToAddImages"
              >
                <svg
                  class="icon icon_add"
                  aria-hidden="true"
                > 
                  <use xlink:href="#iconjia" />
                </svg>
                新增圖片
              </el-button>
            </div>
          </div>

          <div class="step3-content">
            <div class="category-sidebar">
              <div class="sidebar-header">
                <!-- v-model="allCategoriesChecked"  -->
                <el-checkbox 
                  v-model="checkAllCategories"
                  :disabled="!hasAnyTags"
                  :indeterminate="isIndeterminate"
                  @change="handleAllCategoriesChange"
                >
                  快速全選類別
                </el-checkbox>
              </div>
              <div class="category-list">
                <div 
                  v-for="tag in globalTags" 
                  :key="tag.name" 
                  class="category-item"
                >
                  <el-checkbox 
                    v-model="tag.checked" 
                    @change="handleGlobalTagChange(tag)"
                  >
                    {{ tag.name }}
                  </el-checkbox>
                </div>
              </div>
            </div>

            <div class="image-detail-list">
              <div 
                v-for="(img, imgIdx) in detailImages" 
                :key="imgIdx" 
                class="image-detail-card"
              >
                <div class="card-left">
                  <el-image 
                    :src="img.originalImageUrl" 
                    fit="cover" 
                    class="preview-img"
                  />
                  <!-- <div slot="placeholder">
                    加载中...
                  </div> -->
    
                  <div 
                    class="img-mask" 
                    @click="removeAiTagImg(imgIdx)"
                  >
                    <svg
                      class="icon"
                      aria-hidden="true"
                    >
                      <use xlink:href="#iconshanchu-copy" />
                    </svg>
                    移除圖片
                  </div>
                </div>
                <div class="card-right">
                  <div class="card-header">
                    <span class="title">識別出的物件</span>
                    <span class="count">{{ img.tags.length }}個物件</span>
                  </div>
                  <div 
                    v-if="img.tags.length"
                    class="tag-group" 
                  >
                    <div 
                      v-for="(tag, tagIdx) in img.tags" 
                      :key="tagIdx"
                      class="custom-tag-item"
                      :class="{ 'is-active': tag.checked }"
                      @click="toggleTag(tag, img)"
                    >
                      {{ tag.name }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="tags_default"
                  >
                    沒有識別出物件
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="step3-footer">
            <span class="hint">*每張相最少需要選擇<span class="red"> 1 </span>樣物件，最多建議 <span class="red"> 5 </span>樣物件內為最佳效果
              <br>
              <span>當前AI修圖額度 : <span class="ai_count">{{ aiRetouchCount }}</span></span></span>
            <div class="btns">
              <el-button @click="handleCancel">
                取消
              </el-button>
              <el-button 
                type="primary"  
                :disabled="!hasAnyTags"
                @click="confirmAndFinish"
              >
                確認並完成({{ effectiveImageCount }})
              </el-button>
            </div>
          </div> -->
        </div>
      </template>
    </div>
    <div class="step3-footer" v-if="activeStep == 3" >
      <span class="hint">*每張相片最少需要選擇1樣物件
        <br>
        <span class="mr_5">當前AI修圖額度 : <span class="ai_count">{{ aiRetouchCount }}</span></span></span>
      <div class="btns">
        <el-button @click="handleCancel">
          取消
        </el-button>
        <el-button 
          type="primary"  
          :class="[!hasAnyTags ? 'disbut' : '']"
          :disabled="!hasAnyTags"
          @click="confirmAndFinish"
        >
          確認並完成({{ effectiveImageCount }})
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AIPhoto',
  props: {
    // 父组件传入的原始图片数组（包含上传状态等）
    images: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'post'
    },
    draftID: {
      type: [String, Number],
      default: null
    },
    propertyID: {
      type: [String, Number],
      default: null
    },
    isMinimized: {
      type:Boolean,
      default: false
    },
    activeTab: {
      type:String,
      default: ''
    },
  },
  data() {
    return {
      showQuotaPop: false, 
      aiRetouchCount:0,
      activeStep: 1,
      // 必须在 data 中声明，否则 this.aiImgs[index].selected 的修改不是响应式的
      aiImgs: [],
      progress: 0,
      timer: null,
      globalTags: [], // 左侧全局标签状态
      detailImages: [], // 右侧图片及其标签状态
      // allCategoriesChecked: false,
      showLoadingErr:false,
      aiLoading:false,
    };
  },
  computed: {
    // 控制“全选”按钮的勾选状态（纯勾选，不含横杠）
    checkAllCategories: {
      get() {
        if (this.globalTags.length === 0) {return false};
        return this.globalTags.every(tag => tag.checked);
      },
      set(val) {
        // 这里的 set 会在点击全选按钮时触发，由于我们在模板里写了 @change，
        // 实际逻辑在 handleAllCategoriesChange 里处理了，这里可以留空
      }
    },
    // 控制“全选”按钮是否显示为横杠
    isIndeterminate() {
      const checkedCount = this.globalTags.filter(tag => tag.checked).length;
      // 条件：选中的数量大于 0，且小于总数
      return checkedCount > 0 && checkedCount < this.globalTags.length;
    },
    // 1. 核心规则：封装选中的有效图片数组
    // 过滤掉：未勾选的、还在上传中没有路径的图片
    selectedImagesList() {
      return this.aiImgs.filter(img => img.selected && img.imagePath);
    },
    // 2. 统计数量（基于有效图片）
    selectedCount() {
      return this.selectedImagesList.length;
    },
    selectedTotalCount() {
      let count = 0;
      this.detailImages.forEach(img => {
        count += img.tags.filter(t => t.checked).length;
      });
      return count;
    },
    canSubmit() {
      return this.selectedTotalCount > 0;
    },
    hasAnyTags() {
      return this.detailImages.some(img => img.tags && img.tags.length > 0);
    },
    // 计算真正有效（有标签）的图片数量
    effectiveImageCount() {
      return this.detailImages.filter(img => img.tags && img.tags.length > 0).length;
    },
  },
  watch: {
    // 1. 监听最小化状态
    isMinimized(val) {
      if (val) {
        this.showQuotaPop = false;
      }
    },

    // 2. 监听 Tab 切换
    // 注意：如果 activeTab 没传进来，可以监听组件销毁或通过父组件调用方法
    activeTab(newTab) {
      if (newTab !== 'process') {
        this.showQuotaPop = false;
      }
    },
    images: {
      immediate: true, // 组件创建时立即执行一次
      deep: true,      // 深度监听内部属性变化
      handler(newVal) {
        // 执行增量同步
        this.syncImages(newVal);
      }
    }
  },
  created() {
    // 进场快照：只处理当前已经上传成功的图片，或者给所有图片初始化 selected 字段
    // this.initSnapshot();
    this.getAiCount()
  },
  beforeDestroy() {
    if (this.timer) {clearInterval(this.timer)}; // 组件销毁清除定时器
  },
  methods: {
    syncImages(newList) {
      // 1. 建立当前选中状态的缓存 Map
      const selectedMap = new Map();
      if (this.aiImgs) {
        this.aiImgs.forEach(img => {
          if (img.imagePath) {selectedMap.set(img.imagePath, img.selected)};
        });
      }

      // 2. 将父组件的新列表同步到本地显示列表
      this.aiImgs = newList.map(img => {
        // 检查该图片之前是否已经存在于子组件中
        const prevSelected = selectedMap.has(img.imagePath) ? selectedMap.get(img.imagePath) : false;
        
        return {
          ...img,
          // 重要：确保 selected 属性是响应式的
          selected: prevSelected 
        };
      });
    },
    removeAiTagImg(index) {
      // 弹窗确认，防止误操作
      this.$confirm('確定要移除這張圖片嗎？移除後將不會對此圖進行AI處理。', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 1. 獲取要刪除的圖片路徑（用於同步第一頁的狀態）
        const removedImgPath = this.detailImages[index].originalImageUrl.split('?')[0];
        // 2. 從詳情列表中刪除
        this.detailImages.splice(index, 1);

        // 【核心修改】：同步重置第一步數據列表中的選中狀態
        // 遍歷本地圖片列表，找到路徑相同的圖片，將其 selected 設為 false
        const targetInAiImgs = this.aiImgs.find(img => img.imagePath === removedImgPath);
        if (targetInAiImgs) {
          targetInAiImgs.selected = false;
        }
      // this.$set(this.aiImgs[index], 'selected', !this.aiImgs[index].selected);
        
        // 2. 交互反馈
        this.$message({
          type: 'success',
          message: '已移除圖片'
        });

        // 3. 可选逻辑：如果图片全部被删除了，自动退回到第一步
        if (this.detailImages.length === 0) {
          this.activeStep = 1;
        }
        
        // 4. 注意：移除图片后可能影响“全选”状态，需要重新计算一次 globalTags 或校验逻辑
        this.updateGlobalTagsStatus(); 
      }).catch(() => {
        // 取消删除
      });
    },
    updateGlobalTagsStatus() {
      // 1. 获取当前所有剩余图片中 实际存在 的标签名称集合
      const remainingTagsSet = new Set();
      this.detailImages.forEach(img => {
        img.tags.forEach(tag => remainingTagsSet.add(tag.name));
      });

      // 2. 过滤 globalTags：只保留依然存在的标签
      this.globalTags = this.globalTags.filter(gt => remainingTagsSet.has(gt.name));

      // 3. 重新计算状态
      this.globalTags.forEach(globalTag => {
        const relatedLocalTags = [];
        this.detailImages.forEach(img => {
          const found = img.tags.find(t => t.name === globalTag.name);
          if (found) {relatedLocalTags.push(found)};
        });

        if (relatedLocalTags.length > 0) {
          const allLocallyChecked = relatedLocalTags.every(t => t.checked);
          
          /**
           * 核心修复逻辑：
           * 如果当前全局标签已经是 true，但现在有局部标签没勾选了，则设为 false（保持同步）。
           * 如果当前全局标签是 false，即便现在所有局部标签都勾选了，也不要自动把它变回 true。
           * 只有当“原本就是选中状态”且“依然符合全选条件”时，才保持 true。
           */
          if (globalTag.checked && !allLocallyChecked) {
            globalTag.checked = false;
          }
          // 注意：这里去掉了“else { globalTag.checked = allLocallyChecked }”的逻辑
          // 从而防止了“桌子”被意外勾选
        }
      });

      // 4. 更新顶部全选开关
      this.allCategoriesChecked = this.globalTags.length > 0 && this.globalTags.every(gt => gt.checked);
    },
    handleCancel() {
      this.$emit('close'); // 通知父组件关闭 dialog
    },
    syncImagesPreservingSelection() {
      // 获取父组件最新的图片列表
      const latestImages = JSON.parse(JSON.stringify(this.images));
      
      // 建立一个当前已选状态的 Map: { imagePath: selectedStatus }
      const selectedMap = new Map();
      this.aiImgs.forEach(img => {
        if (img.imagePath) {
          selectedMap.set(img.imagePath, img.selected);
        }
      });
      // 生成新的展示列表
      this.aiImgs = latestImages.map(img => {
        return {
          ...img,
          // 如果这张图之前存在，保留它的选中状态；如果是新图，默认为 false
          selected: selectedMap.has(img.imagePath) ? selectedMap.get(img.imagePath) : false
        };
      });
    },
    goToAddImages() {
      // 如果需要保留当前已选的 tag 状态，可以在这里不重置数据
   
      // 不再调用 initSnapshot()，因为那会覆盖掉当前的选中状态
      this.syncImagesPreservingSelection();
      this.getAiCount()
      
      // 如果需要完全重新开始，可以考虑在此处清空部分临时变量
      // this.initSnapshot();
      // 需求修改为 保留选中状态 而非清空图片选中状态 故注释
      // this.aiImgs.forEach(item => {
      //   this.$set(item, 'selected', false);
      // });
      this.handleAllCategoriesChange(false)
      this.activeStep = 1; 
    },
    async getAiCount() { 
      let { data } = await this.axios.post(this.pub.getApi().GetUserPropertyAIRetouchCount);
      if (data.code === 0) {
          this.aiRetouchCount = data.result;
      }
    },

    initSnapshot() {
      // 执行深拷贝，切断与父组件轮询列表的联系
      const snapshot = JSON.parse(JSON.stringify(this.images));
      // 规则：初始化每个对象的 selected 属性，确保 Vue 能够监听它
      this.aiImgs = snapshot.map(img => {
        return {
          ...img,
          // 如果图片还在上传队列中，强制设为不可选（或者后续逻辑处理）
          selected: false 
        };
      });
      this.getAiCount()
    },

    toggleSelect(index) {
      const targetImg = this.aiImgs[index];
      // 规则：如果图片还没上传成功（没有路径），不允许选中
      if (!targetImg.imagePath) {
        this.$message.warning('該圖片尚未上傳完成，請稍後再試。');
        return;
      }
      // 切换选中状态
      this.$set(this.aiImgs[index], 'selected', !this.aiImgs[index].selected);
    },
    handleButtonClick() {
      // 1. 校验次数：如果选中图片数量 > 剩余次数
      if (this.selectedCount > this.aiRetouchCount) {
        this.showQuotaPop = true;
      } else {
        this.showQuotaPop = false;
        this.startAnalysis(); // 次数充足，执行原有的分析逻辑
      }
    },
    async startAnalysis() {
      if (this.selectedCount === 0) {
        this.$message.error('请至少选择一张图片进行分析');
        return;
      }
      this.$emit('update:tagAnalysising', true);
      this.$emit('update:tagSelecting', true);
      this.activeStep = 2;
      this.startFakeProgress(); // 开始模拟进度

      try {
        const imgOriginalPathList = this.selectedImagesList.map(item => item.imagePath);
        
        // 这里的 POST 请求
        const { data } = await this.axios.post(this.pub.getApi().AIAnalyzeImage, { 
          originalImageUrls: imgOriginalPathList 
        });

        if (data.code !== 0) {
          this.handleAnalysisFailure(); // 统一处理业务失败
          return;
        }
        // 接口成功返回
        this.completeProgress(data);
      } catch (error) {
        this.handleAnalysisFailure()
        clearInterval(this.timer);
      }finally{
        this.$emit('update:tagAnalysising', false);
      }
    },
    // 抽取失败处理逻辑，匹配 UI 图中的弹窗效果
    handleAnalysisFailure() {      
      this.$emit('update:tagAnalysising', false); 
      // 使用 $alert 弹窗，只有确认按钮
      this.$alert('分析失敗，請重新進行分析', '提示', {
        confirmButtonText: '確認',
        type: 'info', // 匹配图中的蓝色感叹号图标
        showClose: false, // 强制用户点击确认
        callback: action => {
          this.activeStep = 1; // 失败跳回第一步
          this.progress = 0;
          clearInterval(this.timer);
        }
      });
    },
    // 模拟进度条逻辑
    startFakeProgress() {
      this.progress = 0;
      this.timer = setInterval(() => {
        if (this.progress < 90) {
          // 越往后加得越慢，模拟真实感
          const step = this.progress < 50 ? 5 : 1;
          this.progress += step;
        }
      }, 200);
    },
    // 完成进度并进入下一步
    completeProgress(res) {
      const { result } = res;
      
      // 1. 初始化左侧全局标签
      this.globalTags = result.suggestedItemsToRemove.map(name => ({
        name,
        checked: false
      }));

      /**
       * 2. 【核心修改】：按照原始选择顺序重排右侧图片列表
       * 不要直接用 result.originalImageRelationSuggestedItemsToRemove
       * 而是遍历 this.selectedImagesList (它遵循 images 的原始顺序)
       */
      const apiResults = result.originalImageRelationSuggestedItemsToRemove;
      
      this.detailImages = this.selectedImagesList.map(originalImg => {
        // 找到接口返回中，路径匹配的那一项
        const matchedData = apiResults.find(item => {
          const apiPath = item.originalImageUrl ? item.originalImageUrl.split('?')[0] : '';
          const localPath = originalImg.imagePath ? originalImg.imagePath.split('?')[0] : '';
          return apiPath === localPath;
        });

        // 如果匹配到了，则组装数据；没匹配到（兜底）则返回空标签对象
        if (matchedData) {
          return {
            ...matchedData,
            tags: matchedData.suggestedItemsToRemove.map(tagName => ({
              name: tagName,
              checked: false
            }))
          };
        }
        return null;
      }).filter(item => item !== null); // 过滤掉万一没匹配上的

      // 3. 自动全选逻辑
      if(this.hasAnyTags){
        this.handleAllCategoriesChange(true)
      }
      
      this.progress = 100;
      setTimeout(() => { this.activeStep = 3; }, 500);
    },
    // 完成进度并进入下一步
    // completeProgress(res) {
    //   const { result } = res;
      
    //   // 1. 初始化左侧全局标签
    //   this.globalTags = result.suggestedItemsToRemove.map(name => ({
    //     name,
    //     checked: false
    //   }));

    //   // 2. 初始化右侧图片列表
    //   this.detailImages = result.originalImageRelationSuggestedItemsToRemove.map(img => ({
    //     ...img,
    //     tags: img.suggestedItemsToRemove.map(tagName => ({
    //       name: tagName,
    //       checked: false
    //     }))
    //   }));
    //   if(this.hasAnyTags){
    //     this.handleAllCategoriesChange(true)
    //   }
      
    //   this.progress = 100;
    //   setTimeout(() => { this.activeStep = 3; }, 500);
    // },

    // 逻辑 A：点击左侧全局标签 -> 影响右侧所有同名标签
    handleGlobalTagChange(globalTag) {
      this.detailImages.forEach(img => {
        img.tags.forEach(localTag => {
          if (localTag.name === globalTag.name) {
            localTag.checked = globalTag.checked;
          }
        });
      });
    },
    // 关键：点击右侧局部标签（图片卡片里的）
    handleLocalTagChange(localTag, img) {
      // 找出所有图片中，标签名为 localTag.name 的标签
      const allRelatedLocalTags = [];
      this.detailImages.forEach(i => {
        const found = i.tags.find(t => t.name === localTag.name);
        if (found) {allRelatedLocalTags.push(found)};
      });

      // 逻辑：如果这类局部标签全部被勾选，则勾选左侧对应的全局分类；反之则取消
      const targetGlobal = this.globalTags.find(t => t.name === localTag.name);
      if (targetGlobal) {
        targetGlobal.checked = allRelatedLocalTags.every(t => t.checked);
      }
    },
    // 点击右侧图片上的小标签
  // toggleTag(tag, img) {
  //   tag.checked = !tag.checked;
    
  //   // 关键：同步去修改左侧 globalTags 里的状态
  //   const targetGlobal = this.globalTags.find(gt => gt.name === tag.name);
  //   if (targetGlobal) {
  //     // 检查是否该类别的所有实例都被选中了（或者是根据你的业务逻辑决定）
  //     const allRelatedLocalTags = [];
  //     this.detailImages.forEach(i => {
  //       const found = i.tags.find(t => t.name === tag.name);
  //       if (found) {allRelatedLocalTags.push(found)};
  //     });
  //     // 只有右侧图片中所有同名标签都勾选，左侧才勾选；只要有一个取消，左侧就取消
  //     targetGlobal.checked = allRelatedLocalTags.every(t => t.checked);
  //   }
  // },
    // 新增：手动切换标签状态
    toggleTag(tag, img) {
      tag.checked = !tag.checked; // 手动切换状态
      this.handleLocalTagChange(tag, img); // 触发你原有的联动逻辑
    },
    // 逻辑 B：点击右侧局部标签 -> 检查是否需要取消左侧对应标签
    // handleLocalTagChange(localTag, img) {
    //   if (!localTag.checked) {
    //     // 如果右侧任何一个同名标签取消了，左侧对应的“全选类”必须取消
    //     const targetGlobal = this.globalTags.find(t => t.name === localTag.name);
    //     if (targetGlobal) {targetGlobal.checked = false;}
    //   } else {
    //     // 逻辑 C (可选)：如果所有图片中的该标签都被勾选了，自动勾选左侧（通常不需要，保持单向较好）
    //   }
    // },

    // 逻辑 D：顶部全选
    handleAllCategoriesChange(val) {
      this.globalTags.forEach(tag => {
        tag.checked = val;
        this.handleGlobalTagChange(tag);
      });
    },

    async confirmAndFinish() {
      await this.getAiCount()
      if (this.selectedCount > this.aiRetouchCount) {
        this.$confirm(`AI修圖次數不足，請先於「金幣/鑽石管理 > AI修圖」購買AI修圖額度。<br/>目前AI修圖次數：${this.aiRetouchCount }`, '提示', {
          confirmButtonText: '確認',
          showCancelButton: false,
          type: 'warning',
          customClass: 'ai-confirm' ,
          iconClass: 'el-icon-info',
          dangerouslyUseHTMLString: true,
        }).catch(() => {});
        return; // 拦截，不继续向下执行
      } 
      // 1. 筛选出所有有选中标签的图片数据
      // if(this.mode != 'edit'){
      //   this.propertyID = 0
      // }
      const imagesWithTags = this.detailImages.filter(img => img.tags && img.tags.length > 0);
      const processedList = imagesWithTags.map(img => {
        const cleanUrl = img.originalImageUrl ? img.originalImageUrl.split('?')[0] : '';
        return {
          propertyID: this.mode == 'edit' ? Number(this.propertyID) : 0,   // 从 props 获取并转为数字
          draftID: Number(this.draftID) || 0,       // 从 props 获取并转为数字
          originalImageUrl: cleanUrl,   // 图片路径
          itemsToRemove: img.tags
            .filter(t => t.checked)                 // 只筛选选中的标签
            .map(t => t.name)                       // 提取标签名称数组
        };
      });

      // 2. 校验：检查是否【每一张】图片都至少选了一个标签
      // 如果存在任何一张图片的 removeItems 长度为 0
      const hasEmptySelection = processedList.some(item => item.itemsToRemove.length === 0);
      if (hasEmptySelection) {
        // 弹出提示：每張相最少需要選擇 1 樣物件
        this.$confirm('每張相片最少需要選擇 1 樣物件', '提示', {
          confirmButtonText: '確認',
          showCancelButton: false,
          type: 'warning',
          customClass: 'ai-confirm' ,
          iconClass: 'el-icon-info',
        }).catch(() => {});
        return; // 拦截，不继续向下执行
      }

      // 3. 统计：计算处理图片张数和预计扣减额度
      const totalPics = processedList.length;
      const totalCost = totalPics; // 假设 1 张图片扣减 1 次额度

      // 4. 弹出二次确认窗
      // 提示：本次將處理 X 張圖片，預計扣減 X 次額度
      this.$confirm(`本次將處理 ${totalPics} 張圖片，預計扣減 ${totalCost} 次額度`, '提示', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'ai-confirm' ,
        iconClass: 'el-icon-info',
      }).then(() => {
        // 用户点击确认，执行最终提交
        // this.submitToBackend(processedList);
        this.$emit('submit-analysis', processedList);
        this.$emit('update:tagSelecting', false);

      }).catch(() => {
        this.$emit('update:tagSelecting', false);
        // 用户点击取消
        console.log('用户取消提交');
      });
    },
// ai-photo 子组件内部方法
    // async submitToBackend(payload) {
    //   try {

    //     this.aiLoading = true;
    //     // // 直接发送 payload，不需要外层再包裹 { images: payload }，除非后端明确要求
    //     // // 根据您的注释： AIRetouchImage 接口接收数组
    //     const res = await this.axios.post(this.pub.getApi().AIRetouchImage, payload);
    //     if (res.data.code === 0) {
    //       this.aiLoading = false;
    //       // 成功后的处理，例如跳转到生成页面或 emit 事件
    //       this.$emit('submit-success',res.data.result);
    //     }
    //   } catch (error) {
    //     this.showLoadingErr = true
    //     console.error('提交失败详情：', error);
    //     this.$message.error('提交失败，请重试');
    //   }
    // }
  }

}
</script>
<style lang="less" scoped>

/* 气泡弹窗样式 */
.quota-popover {
  padding: 15px;
  line-height: 1.6;
  font-size: 13px;
  color: #333;

  .popover-content {
    .link-text {
      color: #0064FF; /* 蓝色文字 */
      // cursor: pointer;
      font-weight: bold;
      // &:hover {
      //   text-decoration: underline;
      // }
    }
    
    p {
      margin-bottom: 8px;
    }
  }

  .popover-footer {
    text-align: right;
    margin-top: 12px;
    .el-button{
      border-radius: 5px;
      width: 80px;
      height: 30px;
      background-color: #0064FF;
    }
  }
}
.analysis-footer {
  text-align: center;
  margin-top: 10px;
  
  .submit-btn {
    width: 240px; /* 根据实际设计调整 */
  }
  .disbut{
    background-color: #BBBBBB;
    border-color: #BBBBBB;
  }
  .quota-info {
    margin-top: 8px;
    font-size: 12px;
    color: #666;
  }
  .txt_decor{
    text-align: center;
    color: #DD2200;
    font-size:12px ;
    margin-top : 10px;
  }
}

.ai-photo-container {
  display: flex;
  flex-direction: column;
  height: 589px; /* 根据弹窗高度自适应 */
  background: #fff;
  padding: 20px;
  padding-top:0 ;
  margin-bottom: 66px;
  border-radius: 10px;
  // -------------------------------------
  padding: 15px 20px;
  // .ai-loading-mask {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   background: rgba(255, 255, 255, 0.95);
  //   z-index: 3000;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;

  //   .loading-wrapper {
  //     text-align: center;

  //     .icon-circle {
  //       display: flex; // 关键：使用 flex 居中
  //       justify-content: center;
  //       align-items: center;
  //       width: 60px;
  //       height: 60px;
  //       margin: 0 auto 20px;
        
  //       .el-icon-loading {
  //         font-size: 40px;
  //         color: #409EFF;
  //         // 强制重置旋转中心
  //         display: block; 
  //         line-height: 1; 
  //         margin: 0;
  //       }
  //     }

  //     .loading-text {
  //       font-size: 16px;
  //       color: #303133;
  //       font-weight: bold;
  //       margin-bottom: 8px;
  //     }

  //     .loading-sub {
  //       font-size: 13px;
  //       color: #909399;
  //     }
  //   }
  // }

  /* 上部流程样式 */
  .workflow-steps {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    margin-top: 25px;
    margin-bottom: 15px;
    // border-bottom: 1px solid #f0f0f0;

    .step-item {
      text-align: center;
      color: #909399;
      width: 162px;

      .step-icon {
        // width: 30px;
        // height: 30px;
        // border: 2px dashed #dcdfe6;
        // border-radius: 8px;
        line-height: 30px;
        margin: 0 auto 8px;
        font-size: 40px;
        // border-radius: 50%;
      }
      .step-label { font-weight: bold; font-size: 14px;color: #666666; }
      .step-desc { font-size: 12px; margin-top: 4px;color: #666666; }
      .activetxt{color: #409EFF;}
      &.is-active {
        color: #409EFF;
        // .step-icon { border-style: solid; border-color: #409EFF; background: #ecf5ff; }
      }
    }

    .step-line {
      width: 80px;
      height: 2px;
      background: #f0f0f0;
      margin: 0 10px;
      margin-bottom: 30px; /* 对齐图标中心 */
    }
    .activeline{
      background: #409EFF;

    }
  }
  .analysis-loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    height: 100%;
    text-align: center;

  .loading-content {
    width: 60%; // 进度条宽度
    
    .analysis-title { font-size: 20px; color: #303133; margin-bottom: 10px; }
    .analysis-subtitle { font-size: 14px; color: #909399; margin-bottom: 40px; }

    .progress-wrapper {
      position: relative;
      margin-bottom: 30px;

      .progress-bar-bg {
        height: 12px;
        background: #ebeef5;
        border-radius: 10px;
        position: relative;
        overflow: visible; // 允许百分比气泡溢出
      }

      .progress-inner {
        height: 100%;
        background: linear-gradient(90deg, #409eff, #66b1ff);
        border-radius: 10px;
        transition: width 0.5s ease;
        position: relative;

        .progress-percent {
          position: absolute;
          right: -20px;
          top: -30px;
          background: #409eff;
          color: #fff;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 12px;
          &::after { // 小三角箭头
            content: '';
            position: absolute;
            bottom: -4px;
            left: 50%;
            transform: translateX(-50%);
            border-top: 4px solid #409eff;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
          }
        }
      }

      .progress-nodes {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        .node {
          font-size: 12px;
          color: #c0c4cc;
          position: relative;
          &.is-active { color: #409eff; font-weight: bold; }
        }
      }
    }
    .analysis-notice { font-size: 12px; color: #909399; margin-top: 50px; }
  }
}
.step3-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 10px;

  .step3-content {
    display: flex;
    flex: 1;
    overflow: hidden; // 内部滚动
    gap: 20px;
    margin-top:15px;
    margin-bottom:52px
  }

  /* 左侧栏 */
  .category-sidebar {
    width: 200px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
// -----------------------------
margin-bottom: 16px;
    .sidebar-header {
      padding: 15px;
      border-bottom: 1px solid #f0f0f0;
      background: #fafafa;
    }

    .category-list {
      flex: 1;
      overflow-y: auto;
      padding: 10px 15px;
      // --------------------------
      margin-bottom: 16px;
      // .category-item { margin-bottom: 12px; }
      // 子标签改为右侧选中
      .category-item {
        margin-bottom: 12px;

        /* 核心修改：针对子标签的 checkbox 布局 */
        ::v-deep .el-checkbox {
          display: flex;
          flex-direction: row-reverse; /* 反转：文字在前，框在后 */
          justify-content: space-between; /* 撑开两端对齐 */
          align-items: center;
          width: 100%; /* 占满侧边栏宽度 */
          margin-right: 0; 
        }

        /* 移除原本 label 默认的左间距，并让文字左对齐 */
        ::v-deep .el-checkbox__label {
          padding-left: 0;
          text-align: left;
          flex: 1;
        }

        /* 如果需要调整勾选框与右侧边缘的距离 */
        ::v-deep .el-checkbox__input {
          margin-left: 10px;
        }
      }
    }
  }

  /* 右侧详情 */
  .image-detail-list {
    flex: 1;
    overflow-y: auto;
    padding-right: 10px;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    // -----------------
    margin-bottom: 16px;
    .image-detail-card {
      display: flex;
      border-bottom: 1px solid #ebeef5;
      border-radius: 8px;
      margin-bottom: 20px;
      padding: 15px;
      padding-left: 0px;
      margin-left: 10px;

      .card-left {
        width: 140px;
        position: relative;
        .preview-img { width: 100%; height: 100px; border-radius: 4px; }
        .img-mask {
          position: absolute;
          bottom: 0;
          top: 73px;
          width: 100%; 
          background: rgba(0,0,0,0.5);
          color: #fff; 
          font-size: 12px; 
          text-align: center; 
          padding: 2px 0;
          height: 24px; // 稍微加高一点方便文字居中
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .icon{
            margin-right: 5px;
          }
        }
      }

      .card-right {
        flex: 1;
        padding-left: 20px;
        .card-header {
          display: flex; justify-content: space-between; margin-bottom: 15px;
          .title { font-weight: bold; color: #303133; font-size: 18px;}
          .count { color: #909399; font-size: 12px;padding-top: 10px; }
          
        }
        .tags_default{
          font-size: 22px;
          color: #44444F;
          font-weight: bold;
        }
        .tag-group {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .custom-tag-item {
            padding: 6px 16px;
            font-size: 13px;
            cursor: pointer;
            border-radius: 4px;
            transition: all 0.2s ease;
            user-select: none; // 禁止双击选中文本
            
            // 默认状态（未选中）：灰色背景
            background-color: #FFFFFF; 
            color: #333333;
            border: 1px solid #BBBBBB;

            &:hover {
              background-color: #eef1f6;
            }

            // 选中状态：蓝色背景 + 白色文字
            &.is-active {
              background-color: #00479C;
              border-color: #00479C;
              color: #FFFFFF;
              font-weight: 500;
            }
          }
        }
        // .tag-group {
          // display: flex; flex-wrap: wrap; gap: 10px;
          // ::v-deep .el-checkbox.is-border { margin-left: 0 !important; margin-right: 0; }
        // }
      }
    }
  }

  // .step3-footer {
  //   padding: 15px 0;
  //   border-top: 1px solid #f0f0f0;
  //   display: flex; justify-content: space-between; align-items: center;
  //   .hint { font-size: 12px; color: #909399; }
  //   .red{
  //     color: red;
  //     font-weight: bold;
  //   }
  //   .ai_count{
  //     color: #666666;
  //   }
  // }
    /* Header 布局调整 */
  .result-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    // margin-bottom: 20px;
    // padding-bottom: 15px;
    // border-bottom: 1px solid #f0f0f0;
  }

  .header-left h3 {
    margin: 0 0 8px 0;
    font-size: 18px;
    color: #303133;
  }

  .header-left p {
    margin: 0;
    font-size: 14px;
    color: #606266;
  }

  /* 新增图片按钮样式 */
  .add-img-btn {
    font-weight: bold;
    padding: 10px 20px;
    transition: all 0.3s;
    background-color: #ffffff;
    border: 1px solid #409EFF !important;
    margin-top: 14px;
  }
  .icon_add{
    font-size: 16px;
    margin-right: 4px;
  }

  .add-img-btn:hover {
    background-color: #409EFF !important;
    transform: translateY(-2px); /* 悬浮小动画 */
  }

  /* 按钮图标间距 */
  .add-img-btn i {
    margin-right: 5px;
    font-size: 16px;
  }
}

  /* 主体内容布局 */
  .main-content {
    display: flex;
    flex: 1;
    overflow: hidden; /* 关键：防止整体溢出 */
    margin-top: 20px;
    margin-bottom: 20px;
    .image-grid-title{
      color: #666666;
      font-size: 14px;
      margin-bottom: 10px ;
      position: absolute;
      top: 231px;
    }
  }

  /* 左侧图片网格 */
  .image-grid-wrapper {
    flex: 3;
    overflow-y: auto; /* 纵向滚动 */
    padding-right: 20px;
    
    /* 隐藏滚动条样式（可选） */
    &::-webkit-scrollbar { width: 6px; }
    &::-webkit-scrollbar-thumb { background: #e4e7ed; border-radius: 3px; }
    margin:30px 0;
    .image-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr); /* 每行3张 */
      gap: 15px;
      
      .image-item {
        position: relative;
        aspect-ratio: 4 / 3;
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        border: 2px solid transparent;
        transition: all 0.2s;

        &:hover { transform: scale(1.02); }
        &.is-selected { border: 5px solid #409EFF; }

        .el-image { width: 100%; height: 100%; }
        .uploading-placeholder {
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #909399;
          height: 100%;
          font-size: 16px;
          justify-content: center;
          background-color: #F5F7FA;
        }
        /* 核心修改部分 */
        .el-image {           
          /* 强制内部 img 标签的行为 */
          ::v-deep img {
            width: 100%;
            height: 100%;
            object-fit: fill; /* 这一步确保图片拉伸变形以填满 4:3 的格子 */
          }
        }
        .grid-img {
          width: 100%;
          height: 100%;
          display: block;
        }
        // .selection-overlay {
        //   position: absolute;
        //   top: 5px;
        //   right: 5px;
        //   background: #409EFF;
        //   color: #fff;
        //   border-radius: 50%;
        //   width: 20px;
        //   height: 20px;
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
        //   font-size: 12px;
        // }
      }
    }
  }

  /* 右侧面板 */
  .action-panel {
    flex: 2;
    border-left: 1px solid #f0f0f0;
    padding-left: 20px;
    display: flex;
    flex-direction: column;

    .panel-title { font-size: 18px; margin-bottom: 5px;margin-top: 0; }
    .panel-desc { font-size: 13px; color: #606266; line-height: 1.6; }

    .stat-item {
      margin-top: 10px;
      font-size: 14px;
      color: #44444F;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #E2E2EA;
      .highlight { color: #f56c6c; font-weight: bold; margin-left: 5px; }
    }

    .ai-notice {
      border-radius: 4px;
      // margin-bottom: 20px;
      h4 { font-size: 12px; color: #44444F; margin-bottom: 8px; margin-top: 8px;}
      ul { 
        list-style: none; padding: 0; margin: 0;
        li { font-size: 12px; color: #909399; margin-bottom: 5px; line-height: 1.4; }
      }
    }

    .submit-btn { width: 100%; padding: 12px; font-size: 15px; border-radius: 10px;}
    .quota-info { text-align: center; color: #909399; font-size: 12px; margin-top: 8px; }
  }
}
.ai-height{
    height: 454px;
  }
.step3-footer {
    padding: 15px 30px;
    border-top: 1px solid #f0f0f0;
    background-color: #f9f9f9;
    display: flex; justify-content: space-between; align-items: center;
    .hint { font-size: 12px; color: #909399; }
    .mr_5{
      margin-left:5px
    }
    .disbut{
      background-color: #909399;
    }
    .red{
      color: red;
      font-weight: bold;
    }
    .ai_count{
      color: #666666;
    }
    border-radius: 10px;
  }
</style>